import React from 'react';
import {observer} from 'mobx-react';
import {auth} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import {Button} from 'components';
import BrandedContainer from '../../../../BrandedContainer';

const marketingCopy = (invite) => ({
  info: <FormattedMessage id='user_signup.signup.admin.HR_INFO' values={{companyName: invite.companyName}}/>,
  header: <FormattedMessage id='user_signup.signup.admin.HR_HEADER'/>
});

const PartnerAcceptInvitation = observer(({uiState}) => {
  const {invite} = uiState;
  const user = auth.user;

  return (
    <BrandedContainer {...marketingCopy(invite)}>
      <div className='center mb3'>
        <div className='wl-big-logo mx-auto'></div>
      </div>
      <div className='h2 medium center mb2'>
        <FormattedMessage id='Accept Invitation'/>
      </div>
      <div className='jumbo center mb3'>
        <FormattedMessage id='broker_portal.signup.admin.HR_INVITATION' values={{companyName: invite.companyName}}/>
      </div>
      <div className='bg-white border rounded p3 mb3'>
        <div className='h4 medium mb2'>
          <FormattedMessage id='Logged in as'/>
        </div>
        <div className='jumbo'>
          <div className='mb1'>{user.name}</div>
          <div className='waterloo'>{user.email}</div>
        </div>
      </div>
      <Button className='full-width' onClick={() => uiState.signUp()}>
        <FormattedMessage id='Accept Invitation'/>
      </Button>
    </BrandedContainer>
  );
});

export default PartnerAcceptInvitation;
